<template>
  <div v-if="!+info.is_help" class="my-3">
    <DatePicker
      class="mt-3"
      :disabled="+info.is_help"
      v-if="info.extension_info.type === $defines.Part_Item_Date_Date"
      v-model="dateValue"
      :updateValue="emitContent"
    >
      <template v-slot="{ inputValue, inputEvents }">
        <div class="d-flex align-items-center col-6 position-relative">
          <CFormInput :value="inputValue" v-on="inputEvents" />
          <img
            class="calendar-img position-absolute"
            src="@/assets/icons/calendar.svg"
          />
        </div>
      </template>
    </DatePicker>

    <DatePicker
      class="mt-3"
      v-if="info.extension_info.type === $defines.Part_Item_Date_Date_And_Time"
      v-model="dateValue"
      :disabled="+info.is_help"
      mode="dateTime"
      is24hr
    >
      <template v-slot="{ inputValue, inputEvents }">
        <div class="d-flex align-items-center col-6 position-relative">
          <CFormInput :value="inputValue" v-on="inputEvents" />
          <img
            class="calendar-img position-absolute"
            src="@/assets/icons/calendar.svg"
          />
        </div>
      </template>
    </DatePicker>

    <DatePicker
      class="mt-3"
      v-if="info.extension_info.type === $defines.Part_Item_Date_Date_Interval"
      v-model="dateValue"
      is-range
    >
      <template v-slot="{ inputValue, inputEvents }">
        <div class="d-flex align-items-center">
          <div class="position-relative d-flex align-items-center">
            <CFormInput :value="inputValue.start" v-on="inputEvents.start" />
            <img
              class="calendar-img position-absolute"
              src="@/assets/icons/calendar.svg"
            />
          </div>
          ～
          <div class="position-relative d-flex align-items-center">
            <CFormInput :value="inputValue.end" v-on="inputEvents.end" />
            <img
              class="calendar-img position-absolute"
              src="@/assets/icons/calendar.svg"
            />
          </div>
        </div>
      </template>
    </DatePicker>

    <DatePicker
      class="mt-3"
      v-if="
        info.extension_info.type ===
        $defines.Part_Item_Date_Date_And_Time_Interval
      "
      v-model="dateValue"
      mode="dateTime"
      is24hr
      is-range
    >
      <template v-slot="{ inputValue = dateValue, inputEvents }">
        <div class="d-flex align-items-center">
          <div class="position-relative d-flex align-items-center">
            <CFormInput :value="inputValue.start" v-on="inputEvents.start" />
            <img
              class="calendar-img position-absolute"
              src="@/assets/icons/calendar.svg"
            />
          </div>
          ～
          <div class="position-relative d-flex align-items-center">
            <CFormInput :value="inputValue.end" v-on="inputEvents.end" />
            <img
              class="calendar-img position-absolute"
              src="@/assets/icons/calendar.svg"
            />
          </div>
        </div>
      </template>
    </DatePicker>
  </div>
  <div v-else class="my-3">
        <div class="col-8">
          <div class="d-flex align-items-center mb-2 mt-4">
            <div class="d-flex align-items-center position-relative">
              <CFormInput disabled />
              <img
                class="calendar-img position-absolute"
                src="@/assets/icons/calendar.svg"
              />
            </div>
            <span v-if="(info.extension_info.type === $defines.Part_Item_Date_Date_Interval || info.extension_info.type === $defines.Part_Item_Date_Date_And_Time_Interval)">～</span>
            <div
              v-if="(info.extension_info.type === $defines.Part_Item_Date_Date_Interval || info.extension_info.type === $defines.Part_Item_Date_Date_And_Time_Interval)"
              class="d-flex align-items-center position-relative"
            >
              <CFormInput disabled />
              <img
                class="calendar-img position-absolute"
                src="@/assets/icons/calendar.svg"
              />
            </div>
          </div>
        </div>
      </div>
</template>
<script>
import { DatePicker } from 'v-calendar'
import { ref } from '@vue/reactivity'
import { watch, onMounted } from '@vue/runtime-core'
import {
  Part_Item_Date_Date,
  Part_Item_Date_Date_And_Time,
  Part_Item_Date_Date_Interval,
} from '../../defines'

export default {
  components: {
    DatePicker,
  },
  props: {
    info: {
      type: Object,
      default: () => {},
    },
  },
  emits: ['content'],
  setup(props, { emit }) {
    const dateValue = ref(undefined)
    const timesTampList = ref([])
    watch(dateValue, (a) => {
      if (props.info.extension_info.type === Part_Item_Date_Date) {
        a.setHours(0)
        a.setMinutes(0)
        a.setSeconds(0)
        a.setMilliseconds(0)
        timesTampList.value = [a]
      } else if (
        props.info.extension_info.type === Part_Item_Date_Date_And_Time
      ) {
        timesTampList.value = [a]
      } else if (
        props.info.extension_info.type === Part_Item_Date_Date_Interval
      ) {
        a.start?.setHours(0)
        a.start?.setMinutes(0)
        a.start?.setSeconds(0)
        a.start?.setMilliseconds(0)
        a.end?.setHours(0)
        a.end?.setMinutes(0)
        a.end?.setSeconds(0)
        a.end?.setMilliseconds(0)
        timesTampList.value = [a.start, a.end]
      } else {
        timesTampList.value = [a.start, a.end]
      }
      emitContent()
    })
    const emitContent = () => {
      emit('content', {
        part_item_id: props.info.part_item_id,
        type: props.info.type,
        is_help: +props.info.is_help ? '1' : '0',
        help_message: props.info?.help_message ||'',
        is_finish: [...timesTampList.value].length,
        value_info: !+props.info.is_help && [...timesTampList.value].length ? [...timesTampList.value] : null,
      })
    }
    onMounted(() => {
      emitContent()
    })
    watch(
      () => props.info.value_info,
      (newVal) => {
        let start
        let end
        if(newVal?.[0]){
          start = newVal ? new Date(newVal?.[0]) : undefined
        }
        if(newVal?.[1]){
          end = newVal?.[1] ? new Date(newVal?.[1]) : undefined
        }
        dateValue.value = end ? { start: start, end: end } : start
      },
      { immediate: true },
    )
    watch(
      () => props.info.is_help,
      () => {
        emitContent()
      },
    )
    return {
      emitContent,
      dateValue,
      timesTampList,
    }
  },
}
</script>
<style lang="scss" scoped>
.calendar-img {
  width: 20px;
  right: 5px;
}
</style>
